import React from 'react';
import { Table } from 'antd';

interface ReusableTableProps {
  columns?: Array<any> | []; // Required
  data: Array<object>; // Required
  isCheckable?: boolean; // Optional, default is false
  selectedRowKeys?: React.Key[]; // Optional, default is []
  onSelectionChange?: (selectedKeys: React.Key[], selectedRows: object[]) => void; // Optional
  displayRecords?: number; // Optional, default is 10
  currentPage?: number; // Optional, default is 1
  onPageChange?: (page: number) => void; // Optional
}

const ReusableTable: React.FC<ReusableTableProps> = ({
  columns,
  data,
  isCheckable = false,
  selectedRowKeys = [],
  onSelectionChange,
  displayRecords = 7,
  currentPage = 1,
  onPageChange,
}) => {
  // Row selection logic
  const rowSelection = isCheckable
    ? {
        selectedRowKeys,
        onChange: (keys: any, rows : any) => onSelectionChange?.(keys, rows),
      }
    : undefined;

  return (
    <div>
      <Table
        columns={columns}
        dataSource={data}
        rowSelection={rowSelection}
        pagination={{
          current: currentPage,
          pageSize: displayRecords,
          total: data.length,
          onChange: onPageChange,
        }}
        rowKey={(record: any) => record.key || record.id}
      />
    </div>
  );
};

export default ReusableTable;